









































































import { Component, Vue } from "vue-property-decorator";
import { ExportModel, TemplateSimple } from "@/services/contentTemplates/types";
import { ValidationModel, ValidationType } from "@/services/validation/types";
import { validateForm } from "@/services/validation/validationService";
import { exportTemplates } from "@/services/contentTemplates/contentTemplateService";
import { version } from "@/../package.json";
import validate from "@/directives/validate";

@Component({
    directives: { validate }
})
export default class ExportContentTemplatesModal extends Vue {
    selectedTemplates = [] as Array<TemplateSimple>;
    isBusy = false;
    error = false;

    exportModel = {
        name: "",
        description: "",
        templates: [] as Array<TemplateSimple>,
        cloudVersion: version
    } as ExportModel;

    validators = {
        name: {
            rules: [
                { type: ValidationType.Required }
            ]
        } as ValidationModel
    };

    open(templates: Array<TemplateSimple>) {
        this.selectedTemplates = templates;
        this.exportModel.templates = this.selectedTemplates;
        this.$bvModal.show("modal-export");
    }

    close() {
        this.$bvModal.hide("modal-export");
        this.resetData();
    }

    resetData() {
        this.exportModel = {
            name: "",
            description: "",
            templates: [] as Array<TemplateSimple>,
            cloudVersion: version
        } as ExportModel;
        this.isBusy = false;
        this.error = false;
    }

    async exportContentTemplates() {
        if (!await validateForm([this.validators])) {
            return;
        }
        this.isBusy = true;
        exportTemplates(this.exportModel).then(() => {
            this.$emit("resetExportMode");
            this.isBusy = false;
            this.close();
        }).catch(() => {
            this.isBusy = false;
            this.error = true;
        });
    }
}
